import { render, staticRenderFns } from "./ProfileTags.vue?vue&type=template&id=094bee3b&"
import script from "./ProfileTags.vue?vue&type=script&lang=js&"
export * from "./ProfileTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports